import { Injectable, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TimeOutService implements OnDestroy {
  private inactivityTimeout: number;
  private inactivityInterval: any;
  private routerSub: Subscription;

  constructor(private router: Router) {
    // Cuando el usuario llega al login (por cerrar sesión o por expiración) la sesión ya terminó:
    // se detiene el contador para que no vuelva a mostrar el aviso de expiración estando en el login.
    this.routerSub = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(e => {
        if ((e.urlAfterRedirects || e.url).includes('/cliente/login')) {
          this.detener();
        }
      });
  }

  // El contador se inicia desde las pantallas del portal (resetCounter), no al crear el servicio.
  private startTimer() {
    this.resetTimer();

    // DOM Events
    document.addEventListener('mousemove', this.resetTimer);
    document.addEventListener('keypress', this.resetTimer);
    document.addEventListener('mousedown', this.resetTimer);
    document.addEventListener('touchstart', this.resetTimer);
    document.addEventListener('click', this.resetTimer);
    document.addEventListener('scroll', this.resetTimer, true);
  }

  private resetTimer = () => {
    clearTimeout(this.inactivityInterval);
    this.inactivityTimeout = 3; // Inactivity timeout in minutes
    this.inactivityInterval = setTimeout(this.logout, this.inactivityTimeout * 60 * 1000);
  };

  resetCounter() {
    clearTimeout(this.inactivityInterval);
    this.startTimer();
  }

  // Detiene el contador y deja de escuchar la actividad del usuario.
  detener() {
    clearTimeout(this.inactivityInterval);
    this.inactivityInterval = undefined;
    document.removeEventListener('mousemove', this.resetTimer);
    document.removeEventListener('keypress', this.resetTimer);
    document.removeEventListener('mousedown', this.resetTimer);
    document.removeEventListener('touchstart', this.resetTimer);
    document.removeEventListener('click', this.resetTimer);
    document.removeEventListener('scroll', this.resetTimer, true);
  }

  logout = () => {
    // Se detiene primero: así no se vuelve a ejecutar mientras el usuario ya está en el login.
    this.detener();
    alert('Su sesión ha expirado por inactividad');
    this.router.navigate(['/cliente/login']);
  };

  ngOnDestroy() {
    this.detener();
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }
}
